import styled from 'styled-components';

const ImageWrapPosition = styled.div`
  position: absolute;
  ${(props) => props.pos.left && `left: ${props.pos.left};`}
  ${(props) => props.pos.top && `top: ${props.pos.top};`}
  ${(props) => props.pos.width && `width: ${props.pos.width};`}
  ${(props) => props.pos.zindex && `z-index: ${props.pos.zindex};`}
`;

const ImageContent = styled.img`
  ${(props) =>
    props.data.imageInfo.shape &&
    props.data.imageInfo.shape === "circle" &&
    `border-radius:50%`}

  ${(props) => props.data.addStyle && `${props.data.addStyle}`}
`;

const BlurOverlayImage = styled.div`
  left: -2px;
  right: -2px;
  top: -2px;
  bottom: -2px;
  position: absolute;
  ${(props) =>
    props.data.imageInfo.blur &&
    `background-image:url('${props.data.imageInfo.blur}');`}
  background-repeat:no-repeat;
  background-size: 100% 100%;
`;

export { ImageWrapPosition, ImageContent, BlurOverlayImage };



// WEBPACK FOOTER //
// ./src/components/preview/ImageItem.styled.tsx